import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_3 = {
  key: 0,
  class: "ant-timeline ss-registro-atividade-recurso"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "ant-timeline-item-tail" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "ant-timeline-item-head ant-timeline-item-head-blue" }, null, -1)
const _hoisted_6 = { class: "ant-timeline-item-content ss-registro-atividade-recurso-detalhes" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("b", null, "Data:", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("b", null, "Usuário:", -1)
const _hoisted_9 = {
  class: "ant-timeline-item-content ss-registro-atividade-recurso-detalhes",
  style: {"white-space":"pre"}
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", { class: "ss-registro-atividade-recurso-linha" }, null, -1)
const _hoisted_11 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      keyboard: false,
      centered: "",
      width: 900,
      visible: _ctx.tela.computedVisivel,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tela.computedVisivel) = $event)),
      footer: null
    }, {
      title: _withCtx(() => [
        _createTextVNode(" Histórico ")
      ]),
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.tela.carregandoDados
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                (_ctx.tela.possuiHistorico)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tela.registros, (registro) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: registro.codigo,
                          class: "ant-timeline-item"
                        }, [
                          _hoisted_4,
                          _hoisted_5,
                          _createElementVNode("div", _hoisted_6, [
                            _hoisted_7,
                            _createTextVNode(" " + _toDisplayString(registro.dataHora) + " ", 1),
                            _hoisted_8,
                            _createTextVNode(" " + _toDisplayString(registro.codigoUsuario) + " - " + _toDisplayString(registro.nomeUsuario), 1)
                          ]),
                          _createElementVNode("div", _hoisted_9, _toDisplayString(registro.detalhe), 1),
                          _hoisted_10
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createVNode(_component_a_empty, { description: 'Nenhum histórico foi encontrado para este recurso.' }, null, 8, ["description"])
                    ]))
              ])
            ])
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}